import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";
import { BButton, BForm, BFormGroup, BOverlay, BTable } from "bootstrap-vue";
import mixins from "@@/core/mixins/mixins";
export default {
  name: "activityLogs",
  mixins: [mixins],
  components: {
    BForm,
    BOverlay,
    BFormGroup,
    BTable,
    BButton,
    CustomerSearch,
  },
  data() {
    return {
      disabled: false,
      items: {},
      loading: false,
      url: "admin/activity-logs",
      options: [
        {
          label: "ورود به حساب کاربری",
          value: "login",
        },
        {
          label: "ثبت نام",
          value: "register",
        },
        {
          label: "مشاهده صفحه اصلی",
          value: "viewHomePage",
        },
      ],
      filter: {
        user_id: null,
        type: null,
      },
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "description",
          label: "توضیحات",
        },
        {
          key: "causer_id",
          label: "شناسه کاربر",
        },
        {
          key: "created_at",
          label: "تاریخ",
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData(query = {}) {
      this.disabled = true;
      this.loading = true;
      try {
        const response = await this.$axios.get(this.url, { params: query });
        this.items = response.data.data.activities;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disabled = false;
        this.loading = false;
      }
    },
    submitHandler() {
      this.loadData({
        user_id: this.filter.user_id ? this.filter.user_id.id : null,
        type: this.filter.type ? this.filter.type.value : null,
      });
    },
  },
};
